<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      :persistent='true'
      width="60%"
      height="100%"
      class="modalDialog"
      no-click-animation
    >
      <CardTitle :title="pageTitle" />
      <v-card-actions class="cardWrap__scroll">
        <v-container>
          <v-form
            class="cardWrap__fromArea"
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-row justify="space-around" class="formHeight">
                <v-col cols="2">配信日</v-col>
                <v-col cols="10">
                    <v-text-field
                        class="mr-3 pt-4"
                        maxlength="10"
                        inputmode="tel"
                        type="tel"
                        v-model="fromSetData.delivery_date"
                        @input="fromSetData.delivery_date = $event"
                        @keyup.delete="deleteKeyUp($event)"
                        @keyup="fromSetData.delivery_date = formatDate(fromSetData.delivery_date)"
                        :value="formatedDate(fromSetData.delivery_date)"
                        :rules="[
                            rules.string_type,
                            rules.format_date,
                            rules.correct_date
                        ]"
                    />
                </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">メッセージ</v-col>
              <v-col cols="10">
                <v-textarea
                  v-model="fromSetData.delivery_contents"
                  :rules="[rules.checkEmpty]"
                  auto-grow
                  rows="10"
                  maxlength="5000"
                />
              </v-col>
            </v-row>
            <!-- <v-row justify="start">
              <div class="cardWrap__fromArea__title">有効フラグ</div>
                <v-checkbox v-model="fromSetData.valid_flag" class="mx-2" label="有効フラグ" />
            </v-row> -->
          </v-form>
        </v-container>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
        <v-btn color="green darken-4" text v-if="!changeModeStatus" @click="OnConfirmOverlay">登録</v-btn>
        <v-btn color="green darken-4" text v-if="changeModeStatus" @click="OnConfirmOverlay">変更</v-btn>
      </v-card-actions>
      <AddOverLay
        :page-name="OverLayPageName"
        @processing="OnRunMutation"
        @cancel="closeAddOverLay"
        :process-result="process"
        :OverlaySwitch="addOverlay"
      />
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import AddOverLay from '@/components/overlay/AddOverlay';
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '@/mixins/utility';
import validater from '../../../lib/validater';
import { UPDATE_MESSAGE_DELIVERY, REGIST_MESSAGE_DELIVERY } from '@/constants/delivery_message';

export default {
    components: {
        CardTitle,
        AddOverLay
    },
    mixins: [
        authorityMixin,
        utilityMixin
    ],
    props: [
        'golfCode'
    ],
    data () {
        return {
            pageTitle: null,
            dialog: false,
            changeModeStatus: false,
            addModeStatus: false,
            valid: true,
            rules: {
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct'),
                checkEmpty: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any')
            },
            fromSetData: {
                id: '',
                delivery_date: '',
                delivery_contents: '',
                golf_code: ''
            },
            input: {
                id: '',
                delivery_date: '',
                delivery_contents: '',
                golf_code: ''
            },
            process: {
                result: '',
                resultText: '',
                btnDisabled: 0
            },
            OverLayPageName: '',
            addOverlay: false
        };
    },
    computed: {
        formatedDate: function () {
            return function (pdate) {
                // pdate = this.addHyphen(pdate);
                return pdate;
            };
        }
    },
    methods: {
    /** ----------------------------------------------
     * 初期表示時処理
     * ---------------------------------------------- */
        Initialize () {
            this.addModeStatus = false;
            this.changeModeStatus = false;
            this.addOverlay = false;
            this.changeOverlay = false;
            this.fromSetData = {
                id: '',
                delivery_date: '',
                delivery_contents: '',
                golf_code: ''
            };
        },
        /** ----------------------------------------------
         * 変更
         * ---------------------------------------------- */
        UpdateDelivery: async function () {
            if (this.$refs.form.validate()) {
                try {
                    await this.$apollo.mutate({
                        mutation: UPDATE_MESSAGE_DELIVERY,
                        variables: {
                            id: this.fromSetData.id,
                            golf_code: this.fromSetData.golf_code,
                            delivery_date: this.fromSetData.delivery_date,
                            delivery_contents: this.fromSetData.delivery_contents
                        }
                    }).then(res => {
                        this.dialog = false;
                        this.$emit('from-Dialog');
                    });
                } catch (error) {
                    this.process.result = '1';
                    this.process.resultText = this.$t('result.error.change');
                    this.error = error;
                }
            }
        },
        /** ----------------------------------------------
         * 追加
         * ---------------------------------------------- */
        RegistDelivery: async function () {
            if (this.$refs.form.validate()) {
                try {
                    await this.$apollo.mutate({
                        mutation: REGIST_MESSAGE_DELIVERY,
                        variables: {
                            golf_code: this.fromSetData.golf_code,
                            delivery_date: this.fromSetData.delivery_date,
                            delivery_contents: this.fromSetData.delivery_contents
                        }
                    }).then(res => {
                        this.dialog = false;
                        this.$emit('from-Dialog');
                    });
                } catch (error) {
                    this.process.result = '1';
                    this.process.resultText = this.$t('result.error.regist');
                    this.error = error;
                }
            }
        },
        /** --------------------------------------------
        * モーダル画面を表示
        * -------------------------------------------- */
        OpenModal (item) {
            this.Initialize();
            if (!item) {
                this.fromSetData.id = null;
                this.fromSetData.delivery_date = this.getToday();
                this.fromSetData.delivery_contents = null;
                this.fromSetData.golf_code = this.golfCode;
                this.changeModeStatus = false;
                this.dialog = true;
                this.pageTitle = '登録';
            } else {
                this.fromSetData.id = item.id;
                this.fromSetData.delivery_date = item.delivery_date;
                this.fromSetData.delivery_contents = item.delivery_contents;
                this.fromSetData.golf_code = item.golf_code;
                this.changeModeStatus = true;
                this.dialog = true;
                this.pageTitle = '変更';
            }
            this.$nextTick(function () {
                this.$refs.form.resetValidation();
            });
        },
        /** ----------------------------------------------
         * 当日の日付を取得
         * 例:2020-12-12
         * ---------------------------------------------- */
        getToday () {
            const today = new Date();
            const y = today.getFullYear();
            let m = today.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = today.getDate();
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        /** --------------------------------------------
        * 確認画面を表示
        * -------------------------------------------- */
        OnConfirmOverlay: function () {
            if (this.$refs.form.validate()) {
                this.addOverlay = !this.addOverlay;
                this.OverLayPageName = '随時連絡事項';
            }
        },
        /** --------------------------------------------
        * 処理を実行
        * -------------------------------------------- */
        OnRunMutation: function () {
            // idを持っていなければ新規登録
            if (this.fromSetData.id) {
                this.UpdateDelivery();
            } else {
                this.RegistDelivery();
            }
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.dialog = false;
            this.$emit('from-Dialog');
            this.Initialize();
        },
        /** ----------------------------------------------
         * 確認ダイアログを閉じる
         * ---------------------------------------------- */
        closeAddOverLay () {
            this.$set(this.process, 'result', '');
            this.addOverlay = false;
        }
    }
};
</script>

<style scoped>

.formHeight{
  max-height: 60px;
  max-width: 100%;
}

.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}
</style>
